import axios from 'axios';

const API_URL = '/api/risk-cate';
const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getRiskCates = async (token) => {
  const res = await axios.get(API_URL, h(token));
  return res.data;
};

export const getRiskCateById = async (id, token) => {
  const res = await axios.get(`${API_URL}/${id}`, h(token));
  return res.data;
};

export const createRiskCate = async (data, token) => {
  const res = await axios.post(API_URL, data, h(token));
  return res.data;
};

export const updateRiskCate = async (id, data, token) => {
  const res = await axios.put(`${API_URL}/${id}`, data, h(token));
  return res.data;
};

export const deleteRiskCate = async (id, token) => {
  const res = await axios.delete(`${API_URL}/${id}`, h(token));
  return res.data;
};
